export async function getProductRatings(skus: string) {
  const importedRes = await (
    await fetch(
      `https://api.trustpilot.com/v1/product-reviews/business-units/5df75011e5b7f100012e201f/imported-reviews-summaries?apikey=0fzqrZ1mlBAqQ2L4XIrCsvxzg4l4YCDu&sku=` +
        skus,
    )
  ).json()
  const importedStarRatings = {
    average: importedRes.starsAverage as number,
    reviews: importedRes.numberOfReviews.total as number,
  }
  const res = await await (
    await fetch(
      `https://api.trustpilot.com/v1/product-reviews/business-units/5df75011e5b7f100012e201f?apikey=0fzqrZ1mlBAqQ2L4XIrCsvxzg4l4YCDu&sku=` +
        skus,
    )
  ).json()
  const starRatings = {
    average: res.starsAverage as number,
    reviews: res.numberOfReviews.total as number,
  }

  // ((number of imported product reviews * average imported review score) + (number of truspilot product reviews * average trustpilot review score)) / (number of imported product reviews + number of truspilot product reviews)
  const totalAverage =
    (importedStarRatings.reviews * importedStarRatings.average +
      starRatings.reviews * starRatings.average) /
    (importedStarRatings.reviews + starRatings.reviews)
  const totalReviews = importedStarRatings.reviews + starRatings.reviews
  const combinedReviews = {
    average: totalAverage as number,
    reviews: totalReviews as number,
  }
  return combinedReviews
}
